<template>
  <div class="game-select">
    <van-nav-bar
        v-if="!$inApp"
        left-arrow
        @click-left="backLastPage"
    >
      <template #title>
        <span class="nav-title">选择游戏</span>
      </template>
      <template #left>
        <img src="@/assets/icons/nav-back.png" style="width: 12px; height: 18px;" />
        <span style="color:#333;margin-left:4px;font-size:16px;">返回</span>
      </template>
      <template #right>
        <div @click="openOrderQuery" class="nav-service">
          <van-icon name="search" size="17.5px" color="#465CFF" />
          <span style="font-size:14px;margin-left:4px">查询订单</span>
        </div>
      </template>
    </van-nav-bar>

    <div class="header-section">
      <div class="hero-banner">
        <div class="hero-banner__text">
          <div class="hero-banner__title">电竞助手战区修改</div>
          <div class="hero-banner__desc">选择游戏后填写区服与目标战区</div>
        </div>
        <img class="hero-banner__img" src="@/assets/icons/hero-shield.png" alt="">
      </div>

      <div class="trust-bar">
        <div class="trust-item">
          <img src="@/assets/icons/feature-link.png" alt="" class="trust-icon">
          <div>
            <div class="trust-item__title">专属链接</div>
            <div class="trust-item__desc">官方渠道安全可靠</div>
          </div>
        </div>
        <div class="trust-item">
          <img src="@/assets/icons/feature-scan.png" alt="" class="trust-icon">
          <div>
            <div class="trust-item__title">扫码修改</div>
            <div class="trust-item__desc">一键扫码快速修改</div>
          </div>
        </div>
        <div class="trust-item">
          <img src="@/assets/icons/feature-progress.png" alt="" class="trust-icon">
          <div>
            <div class="trust-item__title">进度可查</div>
            <div class="trust-item__desc">实时跟踪修改进度</div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-head">
      <div class="section-head__title"><img src="@/assets/icons/section-marker.png" class="section-marker" />选择游戏</div>
      <div class="section-head__desc">请选择你需要改战区的游戏</div>
    </div>

    <van-loading v-if="loading" type="spinner" size="24px" style="text-align: center; padding: 20px;">加载中...</van-loading>
    <template v-else>
      <div class="game-grid">
        <div v-for="g in games"
             :key="g.gameId"
             class="game-card"
             :class="{active: selected && selected.gameId === g.gameId}"
             @click="selectGame(g)">
          <img class="game-card__badge" src="@/assets/icons/selected-check.png" v-if="selected && selected.gameId === g.gameId" />
          <img v-if="gameIcon(g)" class="game-card__icon" :src="gameIcon(g)" alt="" @error="hideIcon($event)">
          <div class="game-card__body">
            <div class="game-card__name">{{ g.name }}</div>
            <div class="game-card__tag" v-if="g.tagText">{{ g.tagText }}</div>
            <div class="game-card__desc" v-if="g.descText">{{ g.descText }}</div>
          </div>
        </div>
      </div>

      <div class="divider"></div>

      <div class="section-head style-2">
        <div class="section-head__top">
          <div class="section-head__title"><img src="@/assets/icons/section-marker.png" class="section-marker" />选择服务类型</div>
          <div class="section-head__right" @click="goToHelpPage"><span>帮助中心</span><img src="@/assets/icons/service-chevron.png" class="service-chevron" alt="" /></div>
        </div>
        <div class="section-head__desc">选择本次修改的类型</div>
      </div>

      <div class="service-grid" v-if="selected && selected.modifyTypes && selected.modifyTypes.length">
        <div v-for="mt in selected.modifyTypes"
             :key="mt.value"
             class="service-card"
             :class="{active: modifyType === mt.value}"
             @click="modifyType = mt.value">
          <div class="service-card__title">{{ mt.label }} <img v-if="mt.recommended" src="@/assets/icons/badge-recommended.png" class="tag-rec-img" /></div>
          <div class="service-card__desc" v-if="mt.desc">{{ mt.desc }}</div>
        </div>
      </div>

      <div class="info-tip" v-if="selected && selected.timeRule">
        <img src="@/assets/icons/info.png" class="info-tip__icon"/>
        <span>{{ selected.timeRule }}</span>
      </div>
    </template>

    <div class="bottom-bar" v-if="!loading">
      <div class="bottom-bar__left">
        <template v-if="selected">
          <img v-if="gameIcon(selected)" class="bottom-bar__icon" :src="gameIcon(selected)" alt="">
          <div class="bottom-bar__meta">
            <div class="bottom-bar__row"><span class="bottom-bar__label">已选</span><span class="bottom-bar__value">{{ selected.name }}</span></div>
            <div class="bottom-bar__row" v-if="selectedModifyType"><span class="bottom-bar__label">服务</span><span class="bottom-bar__value">{{ selectedModifyType.label }}</span></div>
          </div>
        </template>
        <div v-else class="bottom-bar__placeholder">请选择游戏</div>
      </div>
      <button class="next-btn" :class="{disabled: !selected}" @click="next">
        <div class="next-btn__main">下一步</div>
        <div class="next-btn__sub">填写区服与目标战区</div>
      </button>
    </div>

  </div>
</template>

<script>
import {NavBar, Icon, Loading as VanLoading, Toast} from "vant";
import {loadGames, gameIcon} from "@/utils/games";

export default {
  name: "GameSelect",
  components: {
    VanNavBar: NavBar,
    VanIcon: Icon,
    VanLoading,
  },
  data() {
    return {
      loading: true,
      games: [],
      selected: null,
      modifyType: null,
    }
  },
  computed: {
    selectedModifyType() {
      if (!this.selected || this.modifyType === null) {
        return null;
      }
      return (this.selected.modifyTypes || []).find(t => t.value === this.modifyType) || null;
    }
  },
  methods: {
    gameIcon,
    hideIcon(e) {
      e.target.style.display = 'none';
    },
    selectGame(g) {
      this.selected = g;
      // 服务类型跟随游戏重置:优先推荐项,否则第一项
      const types = (g && g.modifyTypes) || [];
      const recommended = types.find(t => t.recommended);
      this.modifyType = recommended ? recommended.value : (types.length ? types[0].value : null);
    },
    next() {
      if (!this.selected) {
        Toast('请先选择游戏');
        return;
      }
      const query = {game: this.selected.code};
      if (this.modifyType !== null) {
        query.modifyType = String(this.modifyType);
      }
      this.$router.push({path: '/warzone', query});
    },
    backLastPage() {
      window.history.back();
    },
    goToHelpPage() {
      window.location.href = 'https://yxsaoma.com/help?type=war';
    },
    openOrderQuery() {
      this.$router.push('/warzone/query');
    }
  },
  created() {
    loadGames().then((games) => {
      this.games = games;
      // 默认选中第一个游戏(与设计稿一致),服务类型随之初始化
      this.selectGame(games.length > 0 ? games[0] : null);
      this.loading = false;
    }).catch(() => {
      Toast('游戏列表加载失败');
      this.loading = false;
    });
  }
}
</script>

<style scoped>
.game-select {
  padding-bottom: 96px;
  background: #fff;
  min-height: 100vh;
  box-sizing: border-box;
}

/* ---------- 顶部横幅 ---------- */
.header-section {
  background: linear-gradient(180deg, #eef3ff 0%, #f7faff 60%, #ffffff 100%);
  padding-bottom: 12px;
}

.hero-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px 0 20px;
}

.hero-banner__title {
  font-size: 22px;
  font-weight: 700;
  color: #111;
}

.hero-banner__desc {
  margin-top: 8px;
  font-size: 14px;
  color: #6b7280;
}

.hero-banner__img {
  width: 152px;
  height: 119px;
  object-fit: contain;
  margin-right: -10px; /* pull shield slightly right */
}

/* ---------- 特性栏 ---------- */

.trust-bar {
  display: flex;
  background: #fff;
  border-radius: 12px;
  margin: 14px 16px 0;
  padding: 13px 4px;
  border: 1px solid #f0f1f5;
  box-shadow: 0 2px 10px rgba(70, 92, 255, 0.04);
}

.trust-item {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
}

.trust-item + .trust-item {
  border-left: 1px solid #f0f1f5;
}

.trust-item img.trust-icon {
  width: 33px;
  height: 33px;
  margin-right: 6px;
  flex-shrink: 0;
}

.trust-item__title {
  font-size: 13px;
  font-weight: 700;
  color: #111;
  white-space: nowrap;
}

.trust-item__desc {
  font-size: 10px;
  color: #9ca3af;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transform: scale(0.92);
  transform-origin: left center;
}

/* ---------- 小节标题(蓝色竖条) ---------- */
.section-head {
  margin: 22px 16px 12px;
}

.section-head__title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 700;
  color: #111;
}

.section-marker {
  width: 5px;
  height: 16px;
  margin-right: 6px;
}

.section-head__desc {
  margin-top: 6px;
  padding-left: 10px;
  font-size: 12px;
  color: #9ca3af;
}

.section-head.style-2 .section-head__desc {
  padding-left: 0;
}

/* ---------- 游戏卡片 ---------- */
.game-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 0 16px;
}

.game-card {
  position: relative;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1.5px solid #e8eaf0;
  border-radius: 12px;
  padding: 12px 8px;
  min-height: 96px;
  min-width: 0;
  cursor: pointer;
  box-sizing: border-box;
  overflow: hidden;
}

.game-card.active {
  border: 1.5px solid #465CFF;
  background: #f4f7ff;
}

.game-card__badge {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 18px;
  height: 18.5px;
}

.game-card__icon {
  width: 56px;
  height: 60px;
  margin-right: 8px;
  flex-shrink: 0;
  object-fit: contain;
}

.game-card__body {
  min-width: 0;
}

.game-card__name {
  font-size: 15px;
  font-weight: 700;
  color: #111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.game-card__tag {
  display: inline-block;
  margin-top: 4px;
  font-size: 10px;
  color: #465CFF;
  border: 1px solid #D1DBFF;
  background: #F4F7FF;
  border-radius: 4px;
  padding: 1px 5px;
  line-height: 1.4;
}

.game-card__desc {
  margin-top: 5px;
  font-size: 11px;
  color: #9ca3af;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ---------- 服务类型 ---------- */
.divider {
  height: 1px;
  background: #f0f1f5;
  margin: 24px 16px;
}

.section-head.style-2 {
  margin-top: 0;
}

.section-head__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}


.section-head__right {
  font-size: 13px;
  line-height: 1;
  color: #465CFF;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.service-chevron {
  width: 8px;
  height: 12px;
  display: block;
  flex-shrink: 0;
  object-fit: contain;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  padding: 0 16px;
  margin-top: 16px;
}

.service-card {
  background: #fff;
  border: 1.5px solid #e8eaf0;
  border-radius: 10px;
  padding: 16px 12px;
  cursor: pointer;
  box-sizing: border-box;
  min-height: 80px;
}

.service-card.active {
  border: 1.5px solid #465CFF;
  background: #f4f7ff;
}

.service-card__title {
  font-size: 15px;
  font-weight: 700;
  color: #111;
  display: flex;
  align-items: center;
}

.tag-rec-img {
  width: 29.5px;
  height: 17px;
  margin-left: 6px;
}

.service-card__desc {
  margin-top: 6px;
  font-size: 11px;
  color: #9ca3af;
}

.nav-title {
  font-weight: 700;
  font-size: 17px;
}

.nav-service {
  display: flex;
  align-items: center;
  color: #465CFF;
}

/* ---------- 底部说明条 ---------- */
.info-tip {
  display: flex;
  align-items: center;
  margin: 14px 16px 0;
  background: #f4f7ff;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 11px;
  color: #333;
}

.info-tip__icon {
  width: 14px;
  height: 14px;
  margin-right: 6px;
  flex-shrink: 0;
}

/* ---------- 底部操作栏 ---------- */
.bottom-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background: #fff;
  border-radius: 16px 16px 0 0;
  box-shadow: 0 -6px 20px rgba(17, 24, 39, 0.08);
  display: flex;
  align-items: center;
  padding: 14px 20px;
  padding-bottom: calc(14px + constant(safe-area-inset-bottom));
  padding-bottom: calc(14px + env(safe-area-inset-bottom));
  box-sizing: border-box;
}

.bottom-bar__left {
  display: flex;
  align-items: center;
  min-width: 0;
}

.bottom-bar__icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  margin-right: 16px;
  flex-shrink: 0;
}

.bottom-bar__meta {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.bottom-bar__row {
  font-size: 14px;
  line-height: 1.6;
  white-space: nowrap;
}

.bottom-bar__label {
  color: #9ca3af;
  margin-right: 16px;
}

.bottom-bar__value {
  color: #111;
  font-weight: 600;
}

.bottom-bar__placeholder {
  font-size: 14px;
  font-weight: 600;
}

.next-btn {
  border: none;
  outline: none;
  background: linear-gradient(135deg, #465CFF 0%, #3b6bff 100%);
  color: #fff;
  border-radius: 10px;
  flex: 1;
  min-width: 0;
  margin-left: 32px;
  height: 54px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.next-btn.disabled {
  opacity: 0.5;
}

.next-btn__main {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 1px;
}

.next-btn__sub {
  font-size: 11px;
  opacity: 0.85;
  margin-top: 3px;
}
</style>
